var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGranted('FETCH_CAMPAIGN'))?_c('q-btn',{attrs:{"icon":"fa fa-sync","size":"xs","title":"Refresh Campaign","loading":_vm.isLoading,"flat":""},on:{"click":_vm.refresh}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }